// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-body[data-v-7858157c]{width:100%;padding:10px}.icon-body .icon-list[data-v-7858157c]{height:200px;overflow-y:scroll}.icon-body .icon-list div[data-v-7858157c]{height:30px;line-height:30px;margin-bottom:-5px;cursor:pointer;width:33%;float:left}.icon-body .icon-list span[data-v-7858157c]{display:inline-block;vertical-align:-.15em;fill:currentColor;overflow:hidden}", ""]);
// Exports
module.exports = exports;
